import { req } from 'react-reqq-lite';

import { toastSuccess } from 'modules/common/toast';

import * as c from './constants';
import { transformPayload } from './transformers';

export const postContactUs = ({ payload }, cb) => {
  req.post({
    url: '/v1/send-contact-us',
    payload: transformPayload(payload),
    key: c.POST_CONTACT_US,
    onSuccess: (res) => {
      toastSuccess('Email successfully sent.');
      cb?.(res);
    },
  });
};
